export default __webpack_public_path__ + "static/communities-1-784e9bddbee8393cca0459654994dd1a.jpg";